module.exports = __webpack_public_path__ + "img/skull_stroke.04a0f3ad.png";